import clsx from 'clsx';
import { FrontendLoadLocation } from '@trucksmarter/shared';
import { toPluralized } from '~/utils/pluralize';
import { formatCityAndState } from '~/utils/location';
import { EMPTY_VALUE_PLACEHOLDER } from '~/app/_ui/shared/text-placeholders';
import DallasText from '~/app/_ui/Dallas/Text/DallasText';
import DallasStack from '~/app/_ui/Dallas/Stack/DallasStack';

import styles from './LoadTableStopListSummary.module.scss';

const DEFAULT_STOP_COUNT = 2;

interface Props {
  stops: FrontendLoadLocation[];
}

export default function LoadTableStopListSummary({ stops }: Props) {
  const startLocation = stops.at(0);
  const endLocation =
    stops.length >= DEFAULT_STOP_COUNT ? stops.at(-1) : undefined;
  const extraStopCount = stops.length - DEFAULT_STOP_COUNT;
  const hasExtraStops = extraStopCount > 0;
  return (
    <ul className={styles.root}>
      {startLocation && (
        <>
          <li className={styles.item}>
            <DallasText variant="captionL">
              {formatCityAndState(
                startLocation.address.city,
                startLocation.address.state,
              ) || EMPTY_VALUE_PLACEHOLDER}
            </DallasText>
          </li>
          <li
            className={clsx(
              styles.connectionItem,
              extraStopCount > 0 && styles.connectionItem_extraStops,
            )}
            aria-hidden={!hasExtraStops}
          >
            {hasExtraStops && (
              <DallasStack paddingVertical="3xs">
                <DallasText variant="captionM">{`${extraStopCount} more ${toPluralized(
                  extraStopCount,
                  'stop',
                )}`}</DallasText>
              </DallasStack>
            )}
          </li>
        </>
      )}
      {endLocation && (
        <li className={styles.item}>
          <DallasText variant="captionL">
            {formatCityAndState(
              endLocation.address.city,
              endLocation.address.state,
            ) || EMPTY_VALUE_PLACEHOLDER}
          </DallasText>
        </li>
      )}
    </ul>
  );
}
